import { AppState } from '../';
import { Customer } from './customer.types';

export const customerSelector = (state: AppState): Customer => state.customer.currentCustomer!;
export const customersSelector = (state: AppState): Customer[] => state.customer.customers!;
